import { Guid, ResponseStatus } from '../shared';
import { DataServiceEntity } from './data-service.entity';
import { EfaactDataService } from './efaact.data-service';

export abstract class EfaactDynamicDataService<
    T extends DataServiceEntity<T>
> extends EfaactDataService<T> {
    /**
     * This is a little confusing as it maps values coming in that look like {
        "20160131_TxnID": 276494.00,
        "20160131_Hours": 50.00,
        "20160131_Amount": 0.00
        }
        into a object with the name before _, and properties of the name after the _, and values, so they end up looking like:
        '20160131': {
            TxnID: 276494,
            Hours: 50,
            Amount: 0
        },
        '20160229': {
            TxnID: null,
            Hours: null,
            Amount: null
        },
        '20160331': {
            TxnID: null,
            Hours: null,
            Amount: null
        },
        it leaves any properties without _  alone
     * @param item {T}
     */
    mapItems(item: T): T {
        const mapped = {
            ...item,
            id: Guid.newGuid()
            // any transformations here, i.e. Dates
        };

        const keys = Object.keys(item);
        const dispCols = keys
            .filter(x => x !== 'Row_Version')
            .filter(x => x.includes('_'));
        const dynCols = dispCols.reduce((a, c) => {
            const k = c.split('_')[0];
            const k1 = c.split('_')[1];
            const cur = a[k] || {};

            cur[k1] = item[c];
            return Object.assign(a, {
                ...a,
                [k]: cur
            });
        }, {});

        dispCols.map(x => delete mapped[x]);
        const ret = {
            ...mapped,
            ...dynCols,
            Status: { StatusCode: ResponseStatus.None, Message: '' }
        };
        this.log.verbose({
            type: `${this.entityName}DataService(EfaactDynamicDataService):mapItems`,
            item,
            ret
        });
        return ret;
    }
    mapGetResponse(resp) {
        this.log.verbose({
            type: `${this.entityName}DataService(EfaactDynamicDataService):mapResponse:resp`,
            resp
        });
        if (typeof resp === 'string' || resp instanceof String) {
            return JSON.parse(resp as string) as T[];
        }
        return resp;
    }
}
